import { useLocation } from 'react-router'

import { OFFER_ROUTES, PERSONAL_LOAN_ROUTES, PREQUAL_ROUTES } from 'app/utils/constants'

/**
 * Hook to determine whether the back button should be shown based on current pathname
 * @returns {boolean} Whether the back button should be displayed
 */
export default function useShowBackButton(): boolean {
    const { pathname } = useLocation()

    switch (pathname) {
        // landing pages should not have a back button
        case '/prequal':
        case '/personal-loan':
            return false
        default:
            break
    }

    // these pages should not have a back button
    if (
        pathname.includes(PREQUAL_ROUTES.LOAN_AMOUNT) ||
        pathname.includes(PREQUAL_ROUTES.DECLINED) ||
        pathname.includes(PERSONAL_LOAN_ROUTES.DECLINED) ||
        pathname.includes(PERSONAL_LOAN_ROUTES.FLINKS_CONNECT) ||
        pathname.includes(PERSONAL_LOAN_ROUTES.FLINKS_STATUS_CHECK) ||
        pathname.includes(OFFER_ROUTES.AFFILIATE_OFFER) ||
        pathname.includes(OFFER_ROUTES.EMBEDDED_OFFER) ||
        pathname.includes(OFFER_ROUTES.FIG_TO_KIZZO_OFFER) ||
        pathname.includes(OFFER_ROUTES.KIZZO_TO_FIG_OFFER) ||
        pathname.includes(OFFER_ROUTES.KIZZO_TO_KIZZO_OFFER) ||
        pathname.includes(PERSONAL_LOAN_ROUTES.PENDING)
    ) {
        return false
    }

    return true
}
